import React, { useEffect, useReducer, useState } from "react";
import logoo from "../pictures/TheBestescafflogo.png";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addCompanyDetails,
  addCompanyDocuments,
  adminSubscribed,
  checkToken,
  deleteFile,
  getCompanydata,
  signOut,
} from "../store/adminSlice";
import validator from "../functions/Validator";
import Swal from "sweetalert2";
import Logo from "../components/Logo";
import { adminActions } from "../store/adminSlice";
import URL from "../functions/URLString";
import axios from "../functions/axios";

function AdminUpload() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const subscribed = useSelector((state) => state.admin.subscribed);
  const email = useSelector((state) => state.admin.email);
  const _id = useSelector((state) => state.admin._id);
  const stateCompanyDetails = useSelector(
    (state) => state.admin.companyDetails
  );
  const stateDocuments = useSelector((state) => state.admin.companyDocuments);
  const tokenCheck = useSelector((state) => state.admin.tokenCheck);
  const stateSwalAlert = useSelector((state) => state.admin.swalAlert);
  const [data, setData] = useState(stateCompanyDetails);
  const [logo, setLogo] = useState();
  const [documents, setDocument] = useState([]);
  const [logoup, setlogoup] = useState();

  const queryParameters = new URLSearchParams(window.location.search);
  const session_id = queryParameters.get("session_id");
  const redirectID = queryParameters.get("id");
  const statesignOut = useSelector((state) => state.admin.signOut);
  const [token, setToken] = useState(true);

  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);
  const dispatcGetcompanyData = () => {
    dispatch(getCompanydata(_id));
  };
  useEffect(() => {
    console.log(session_id, "session");
    if (session_id) {
      setToken(false);

      axios
        .post(
          "/admin/stripetokencheck",
          { token_id: session_id },
          {
            headers: {
              authorization:
                "arham BnD3Tb4QN4xGzX85XQNH252qvb07K05MrAEgHblyOkssyHLXlqOTVqnpfH6lvhj",
            },
          }
        )
        .then((res) => {
          if (res.data.message === "validToken") {
            dispatch(adminSubscribed({ _id: _id, adminID: _id }));
          } else {
            dispatch(signOut());
            navigate("/");
          }
        });
    } else if (subscribed === false) {
      console.log("subscribed");
      dispatch(signOut());
      navigate("/");
    } else if (!email) {
      console.log("email");
      navigate("/");
      dispatch(signOut());
    } else if (redirectID === "12345") {
      navigate("/liveprojects");
    } else {
      dispatch(getCompanydata(_id));
    }

    setData(stateCompanyDetails);
    dispatch(adminActions.removeSwalAlert());
  }, []);

  useEffect(() => {
    setData(stateCompanyDetails);
  }, [stateCompanyDetails]);

  useEffect(() => {
    console.log("hello world");
    if (stateSwalAlert === "UploadCompanyDocumentsFirst!") {
      console.log("here");

      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly Add Company Details first!",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
      });
    }
  }, [stateSwalAlert]);

  const submit = (event) => {
    event.preventDefault();
    const formData = new FormData();

    formData.append("customerOrCompanyName", data.customerOrCompanyName);
    formData.append("telephone", data.telephone);
    formData.append("email", data.email);
    formData.append("address1", data.address1);
    formData.append("address2", data.address2);
    formData.append("postCode", data.postCode);
    formData.append("companyLogo", logo);
    formData.append("adminID", _id);

    Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      cancelButtonColor: "#60c088",
      confirmButtonColor: "#60c088",
      denyButtonColor: "#60c088",
      confirmButtonText: "Save changes",
    }).then((result) => {
      if (result.isConfirmed) {
        if (
          logo === undefined ||
          data.customerOrCompanyName === "" ||
          data.telephone === "" ||
          data.email === "" ||
          data.address2 === "" ||
          data.address1 === "" ||
          data.postCode === ""
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            confirmButtonColor: "#60c088",
            text: "Kindly fill all the inputs & Upload Logo !",
          });
          return;
        } else {
          dispatch(addCompanyDetails(formData)).then(() => {
            Swal.fire({
              icon: "success",
              title: "Saved",
              confirmButtonColor: "#60c088",
            });
            navigate("/adminupload");
          });
        }
      }
    });
  };
  const submitDocument = (e) => {
    e.preventDefault();
    const formData = new FormData();

    for (let i = 0; i < documents.length; i++) {
      formData.append("companyDocument", documents[i]);
    }
    formData.append("adminID", _id);
    dispatch(addCompanyDocuments(formData));
  };

  const deleteFilee = (thtFilee) => {
    var nn = { thtFile: thtFilee, adminID: _id };
    console.log(nn);
    dispatch(deleteFile(nn));
  };

  return (
    <div className="w-full flex flex-col h-full bg-gray-50">
      {/* Header with back button */}
      <div className="w-full bg-white shadow-md px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <button
            onClick={() => navigate("/liveprojects")}
            className="mr-3 text-gray-700 hover:text-lightgreen transition-colors"
          >
            <ArrowBackIcon />
          </button>
          <img src={logoo} alt="Escaff Logo" className="h-10" />
        </div>
        <button
          onClick={() => navigate("/liveprojects")}
          className="text-gray-500 hover:text-lightgreen transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <p className="text-lg sm:text-xl font-medium text-gray-800 mb-6">
            Welcome to SDL Pro Management lets get started by setting up your
            company, upload your documents and set up your staff
          </p>

          <div className="flex flex-col w-full">
            <form encType="multipart/form-data">
              <div className="flex flex-col md:flex-row w-full overflow-hidden gap-6">
                <div className="flex w-full md:w-1/2 flex-col">
                  <div className="flex items-start mb-4">
                    <div className="bg-lightgreen text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0 mr-3">
                      <span>1</span>
                    </div>
                    <div className="flex flex-col w-full">
                      <p className="font-semibold text-sm mb-1">
                        Customer / Company Name
                      </p>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            customerOrCompanyName: validator(e.target.value),
                          })
                        }
                        value={data.customerOrCompanyName}
                        type="text"
                        required
                      />
                      <p className="font-semibold text-sm mb-1 mt-3">
                        Telephone
                      </p>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            telephone: validator(e.target.value),
                          })
                        }
                        value={data.telephone}
                        type="text"
                        required
                      />
                      <p className="font-semibold text-sm mb-1 mt-3">Email</p>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({ ...data, email: validator(e.target.value) })
                        }
                        value={data.email}
                        type="email"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="flex w-full md:w-1/2 flex-col">
                  <div className="flex flex-col w-full space-y-3">
                    <p className="font-semibold text-sm mb-1">Address</p>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          address1: validator(e.target.value),
                        })
                      }
                      value={data.address1}
                      type="text"
                      required
                    />
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          address2: validator(e.target.value),
                        })
                      }
                      value={data.address2}
                      type="text"
                    />
                    <p className="font-semibold text-sm mb-1">Postcode</p>
                    <div className="flex flex-col sm:flex-row w-full items-start sm:items-center gap-3">
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full sm:w-28 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            postCode: validator(e.target.value),
                          })
                        }
                        value={data.postCode}
                        type="text"
                        required
                      />
                      <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2">
                        <p className="text-sm font-medium">
                          Upload your company Logo
                        </p>
                        <div className="flex space-x-2">
                          <label
                            htmlFor="file-upload"
                            className="h-10 rounded-md flex items-center px-4 text-white cursor-pointer bg-lightgreen hover:bg-darkgreen transition-colors"
                          >
                            <input
                              className="absolute -ml-5 opacity-0"
                              value={logoup}
                              onChange={(e) => setLogo(e.target.files[0])}
                              style={{ width: "90px", cursor: "pointer" }}
                              id="file-upload"
                              type="file"
                              required
                            />
                            Select
                          </label>
                          <button
                            onClick={submit}
                            className="h-10 rounded-md flex items-center px-4 text-white cursor-pointer bg-lightgreen hover:bg-darkgreen transition-colors"
                            type="button"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* second section */}
              <div className="flex flex-col md:flex-row w-full mt-10 gap-6">
                <div className="flex flex-col w-full md:w-2/5 space-y-6">
                  <div className="flex items-start">
                    <div className="bg-lightgreen text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0 mr-3">
                      <span>2</span>
                    </div>
                    <div className="flex flex-col w-full">
                      <div className="flex flex-col md:flex-row items-start md:items-center justify-between w-full gap-4">
                        <div>
                          <p className="font-semibold text-sm">
                            Upload your company documents
                          </p>
                          <p className="text-xs text-gray-500">
                            i.e Insurance, public, Liability , (not health &
                            safety)
                          </p>
                        </div>
                        <div className="flex space-x-2">
                          <label
                            htmlFor="doc-upload"
                            className="h-10 rounded-md flex items-center justify-center px-4 text-white cursor-pointer bg-lightgreen hover:bg-darkgreen transition-colors"
                          >
                            <input
                              className="absolute -ml-5 opacity-0"
                              onChange={(e) => setDocument(e.target.files)}
                              multiple
                              style={{ width: "90px", cursor: "pointer" }}
                              id="doc-upload"
                              type="file"
                              required
                            />
                            Select
                          </label>
                          <button
                            onClick={submitDocument}
                            className="h-10 rounded-md flex items-center justify-center px-4 text-white cursor-pointer bg-lightgreen hover:bg-darkgreen transition-colors"
                            type="button"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="bg-lightgreen text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0 mr-3">
                      <span>3</span>
                    </div>
                    <div className="flex flex-col w-full">
                      <div className="flex flex-col md:flex-row items-start justify-between w-full">
                        <div>
                          <p className="font-semibold text-sm">
                            Add key members of staff
                          </p>
                          <p className="text-xs text-gray-500">
                            Add your key members of staff that will be allocated
                            to jobs, so you can keep track of who is working on
                            what job.
                          </p>
                        </div>
                        <button
                          onClick={() => navigate("/staffmember")}
                          className="h-10 w-32 mt-3 md:mt-0 rounded-md flex items-center justify-center text-white cursor-pointer bg-lightgreen hover:bg-darkgreen transition-colors"
                          type="button"
                        >
                          Add staff
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col w-full md:w-3/5">
                  <div className="bg-white rounded-lg border border-gray-200 p-4">
                    <div className="mb-3">
                      <p className="text-sm font-semibold">
                        Uploaded Documents
                      </p>
                      <p className="text-xs text-gray-500">
                        (.png, .jpg, .gif, .jpeg, .doc, .docx, .rft, .xls,
                        .xlsx, .ppt, .pptx, .txt, .pdf )
                      </p>
                    </div>
                    <div className="overflow-hidden rounded-lg border border-gray-200">
                      <table className="w-full">
                        <thead>
                          <tr className="bg-lightgreen">
                            <th className="text-start px-4 py-2 text-xs text-white font-medium">
                              File Name
                            </th>
                            <th className="w-32 px-4 py-2 text-xs text-white font-medium">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {stateDocuments.length > 0 ? (
                            stateDocuments.map((data) => {
                              var name = data.split("-");
                              return (
                                <tr
                                  key={data}
                                  className="border-t border-gray-200"
                                >
                                  <td className="px-4 py-3 text-sm">
                                    {name[3]}
                                  </td>
                                  <td className="px-4 py-3">
                                    <div className="flex justify-center space-x-4">
                                      <a
                                        href={`${URL}/uploads/${data}`}
                                        download
                                      >
                                        <div className="flex flex-col items-center cursor-pointer">
                                          <UploadFileIcon
                                            sx={{
                                              width: "22px",
                                              height: "22px",
                                            }}
                                            className="text-lightgreen hover:text-darkgreen transition-colors"
                                          />
                                          <p className="text-[10px]">View</p>
                                        </div>
                                      </a>
                                      <div
                                        onClick={(e) => deleteFilee(data)}
                                        className="flex flex-col items-center cursor-pointer"
                                      >
                                        <DeleteIcon
                                          sx={{ width: "22px", height: "22px" }}
                                          className="text-lightgreen hover:text-darkgreen transition-colors"
                                        />
                                        <p className="text-[10px]">Delete</p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="2"
                                className="px-4 py-3 text-sm text-center text-gray-500"
                              >
                                No documents uploaded yet
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminUpload;
